import React from 'react';

import WaitingRoomContent from '../WaitingRoomContent';

function InactiveRoomContent({ viewProps }) {
  return <WaitingRoomContent viewProps={viewProps} />;
}

export default InactiveRoomContent;
